import { useEffect } from 'react';
import { Clientes } from '../component/Clientes';
import { Footer } from '../component/Footer';
import Header from '../component/Header';
import { ComoLoHacemos } from '../component/Nosotros/ComoLoHacemos';
import NosotrosCover from '../component/Nosotros/NosotrosCover';
import NosotrosServicios from '../component/Nosotros/NosotrosServicios';

export const Nosotros = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Header />
      <NosotrosCover />
      <NosotrosServicios  />
      <ComoLoHacemos />
      <Clientes />
      <Footer />
    </div>
  )
}
